// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10502-根据用户查询可用订单项 根据用户手机号查询可用的订单项 POST /web/v1/usage/canUseItemList */
export async function getCanUseItemList(
  body: API.SwimUsageCanUseItemListVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimUsageCanUseItemVo>(
    "/web/v1/usage/canUseItemList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10501-预约记录列表查询 分页查询预约记录列表，支持预约ID、游泳者姓名/电话、预约时间范围、会员姓名/电话、使用状态等多条件筛选 POST /web/v1/usage/list */
export async function getUsagePageList(
  body: API.SwimUsagePageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimUsageListVo>(
    "/web/v1/usage/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        ...body,
        page: body.current,
        current: undefined,
      },
      ...(options || {}),
    }
  );
}

/** 10505-今日使用数据统计 获取今日使用数据统计，包括预约、入场、完成等各状态数量 GET /web/v1/usage/todayStatistics */
export async function getTodayStatistics<T>(options?: { [key: string]: any }) {
  return request<API.ResponseVO<T>>("/web/v1/usage/todayStatistics", {
    method: "GET",
    ...(options || {}),
  });
}

/** 10504-预约使用状态变更（手环机回调） 更新预约使用状态，通常由手环机设备回调 POST /web/v1/usage/updateStatus */
export async function updateUsageStatus(
  body: API.SwimUsageUpdateStatusVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/usage/updateStatus", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10507-批量绑定手环 批量为预约记录绑定手环 POST /web/v1/usage/usage/batchBindBracelet */
export async function batchBindBracelet(
  body: API.SwimUsageBatchBindVO[],
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimUsageBatchResultVO>(
    "/web/v1/usage/usage/batchBindBracelet",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10511-批量预约作废 仅允许未领取手环的周期卡预约进行作废，作废后返还可用次数 POST /web/v1/usage/usage/batchCancel */
export async function batchCancelUsage(
  body: string[],
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimUsageBatchResultVO>(
    "/web/v1/usage/usage/batchCancel",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10508-批量解绑手环（离场） 批量解绑手环并处理离场逻辑 POST /web/v1/usage/usage/batchUnbindBracelet */
export async function batchUnbindBracelet(
  body: number[],
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimUsageBatchResultVO>(
    "/web/v1/usage/usage/batchUnbindBracelet",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10509-创建手环丢失订单 为丢失手环的预约记录创建赔偿订单 POST /web/v1/usage/usage/createBraceletLostOrder */
export async function createBraceletLostOrder(
  body: API.SwimBraceletLostOrderCreateVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimBraceletLostOrderVO>(
    "/web/v1/usage/usage/createBraceletLostOrder",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10506-查询预约记录 查询预约记录列表，支持订单ID、手环编号、使用状态、时间范围等条件筛选 POST /web/v1/usage/usage/list */
export async function queryUsageList(
  body: API.SwimUsageQueryVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimUsageVO>("/web/v1/usage/usage/list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10510-快速预约并绑环 批量为订单项创建预约使用并绑定手环，预约时间与线下售票一致 POST /web/v1/usage/usage/quickUseBind */
export async function quickUseBind(
  body: API.QuickUsageBindItemVo[],
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOQuickUsageBindRespVO>(
    "/web/v1/usage/usage/quickUseBind",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10503-订单预约使用（打印二维码） 创建订单预约使用记录并生成二维码 POST /web/v1/usage/use */
export async function createUsage(
  body: API.SwimUsageUseVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimUsageUseRespVo>("/web/v1/usage/use", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
